import {
  ADD_FLEET,
  ADD_FLEET_SUCCESS,
  GET_FLEET_BY_FLEET_ID,
  GET_FLEET_BY_FLEET_ID_SUCCESS,
  CLEAN_FASTAG_TRANSACTION_HISTORY,
  GENERATE_MASTER_ACCOUNT_STATEMENT,
  GENERATE_MASTER_ACCOUNT_STATEMENT_SUCCESS,
  GENERATE_FASTAG_VEHICLE_STATEMENT,
  GENERATE_FASTAG_VEHICLE_STATEMENT_SUCCESS,
  CLEAN_FLEET_LOADER,
  UPDATE_FLEET,
  UPDATE_FLEET_SUCCESS,
  ADVANCED_VEHICLE_LIST,
  ADVANCED_VEHICLE_LIST_SUCCESS,
  SAVE_VEHICLE_PROFILE_DATA,
  SAVE_VEHICLE_PROFILE_DATA_SUCCESS,
  EDIT_VEHICLE_PROFILE_DATA,
  EDIT_VEHICLE_PROFILE_DATA_SUCCESS,
  GET_VEHICLE_PROFILE_DATA,
  CLEAR_VEHICLE_PROFILE_DATA,
  GET_VEHICLE_PROFILE_DATA_SUCCESS,
  GET_KARZA_VEHICLE_DATA,
  CLEAR_KARZA_VEHICLE_DATA,
  GET_KARZA_VEHICLE_DATA_SUCCESS,
  GET_SERVICE_HISTORY,
  CLEAR_SERVICE_HISTORY,
  GET_SERVICE_HISTORY_SUCCESS,
  DELETE_SERVICE_HISTORY,
  DELETE_SERVICE_HISTORY_SUCCESS,
  GET_SERVICE_ITEMS,
  GET_SERVICE_ITEMS_SUCCESS,
  ADD_SERVICE_ITEMS,
  ADD_SERVICE_ITEMS_SUCCESS,
  SAVE_KARZA_VEHICLE,
  SAVE_KARZA_VEHICLE_SUCCESS,
  UPDATE_KARZA_VEHICLE,
  UPDATE_KARZA_VEHICLE_SUCCESS,
  GET_FLEET_ANALYTICS,
  GET_FLEET_ANALYTICS_SUCCESS,
  GET_GPS_STATUS,
  GET_GPS_STATUS_SUCCESS,
  GPS_CONNECT,
  GPS_CONNECT_SUCCESS,
  GET_GPS_DATA,
  GET_GPS_DATA_SUCCESS,
  LAST_LOCATION,
  LAST_LOCATION_SUCCESS,
  GPS_COMPUTED_VEHICLE_DATA,
  GPS_COMPUTED_VEHICLE_DATA_SUCCESS,
  CLEAN_GPS_COMPUTED_VEHICLE_DATA,
  DOWNLOAD_VEHICLE_LEDGER,
DOWNLOAD_VEHICLE_LEDGER_SUCCESS,
CLEAN_LAST_LOCATION_DATA,
UPLOAD_TOLL_TXN,
UPLOAD_TOLL_TXN_SUCCESS
} from "../storeTypes";

export function addFleet(obj, callBack,toggleModalToast,handleCloseToast) {
  return {
    type: ADD_FLEET,
    payload: obj,
    callBack,
    toggleModalToast,
    handleCloseToast
  };
}
export function addFleetSuccess(data) {
  return {
    type: ADD_FLEET_SUCCESS,
    payload: data,
  };
}

export function getFleetByID(id) {
  return {
    type: GET_FLEET_BY_FLEET_ID,
    id,
  };
}

export function saveKarzaVehicle(payload, callBack) {
  return {
    type: SAVE_KARZA_VEHICLE,
    payload,
    callBack,
  };
}
export function saveKarzaVehicleSuccess(payload) {
  return {
    type: SAVE_KARZA_VEHICLE_SUCCESS,
    payload,
  };
}

export const updateKarzaVehicleAction = (payload, callBack) => {
  return {
    type: UPDATE_KARZA_VEHICLE,
    payload,
    callBack,
  };
};
export const updateKarzaVehicleSuccess = payload => {
  return {
    type: UPDATE_KARZA_VEHICLE_SUCCESS,
    payload: payload,
  };
};

export const getGpsStatusAction = (payload, callBack) => {
  return {
    type: GET_GPS_STATUS,
    payload,
    callBack,
  };
};
export const getGpsStatusSuccess = payload => {
  return {
    type: GET_GPS_STATUS_SUCCESS,
    payload: payload,
  };
};



export const gpsConnectAction = (payload, callBack) => {
  return {
    type: GPS_CONNECT,
    payload,
    callBack,
  };
};
export const gpsConnectSuccess = payload => {
  return {
    type: GPS_CONNECT_SUCCESS,
    payload: payload,
  };
};



export const getGpsDataAction = (payload, callBack) => {
  return {
    type: GET_GPS_DATA,
    payload,
    callBack,
  };
};
export const getGpsDataSuccess = payload => {
  return {
    type: GET_GPS_DATA_SUCCESS,
    payload: payload,
  };
};


export const getGpsLastLocationAction = (payload, callBack) => {
  return {
    type: LAST_LOCATION,
    payload,
    callBack,
  };
};
export const getGpsLastLocationSuccess = payload => {
  return {
    type: LAST_LOCATION_SUCCESS,
    payload: payload,
  };
};

export function cleanGpsLastLocationData() {
  return { type: CLEAN_LAST_LOCATION_DATA };
}
export const getGpsComputedDataAction = (payload, callBack) => {
  return {
    type: GPS_COMPUTED_VEHICLE_DATA,
    payload,
    callBack,
  };
};
export const getGpsComputedDataSuccess = payload => {
  return {
    type: GPS_COMPUTED_VEHICLE_DATA_SUCCESS,
    payload: payload,
  };
};

export function cleanGetGpsComputedData() {
  return { type: CLEAN_GPS_COMPUTED_VEHICLE_DATA };
}




export function getFleetByIDSuccess(data) {
  return {
    type: GET_FLEET_BY_FLEET_ID_SUCCESS,
    payload: data,
  };
}

export const cleanFleetTransactionHistory =()=>{
  console.log("action-> fleet-- clean");
  return {
   type:CLEAN_FASTAG_TRANSACTION_HISTORY,
  };
  }
  export function getMasterAccountStatement(data, callback) {
    console.log("api",data)
    return {
      type: GENERATE_MASTER_ACCOUNT_STATEMENT,
      payload:data,
      callback
    };
  }
  export function getMasterAccountStatementSuccess(data) {
    return {
      type: GENERATE_MASTER_ACCOUNT_STATEMENT_SUCCESS,
      payload:data
    };
  };
  export function getFastagVehicleHistoryStatement(userId ,data,callback) {
    return {
      type: GENERATE_FASTAG_VEHICLE_STATEMENT,
      payload:data,
      userId:userId,
      callback
    };
  };
  export function getFastagVehicleHistoryStatementSuccess(data) {
    return {
      type: GENERATE_FASTAG_VEHICLE_STATEMENT_SUCCESS,
      payload:data
    };
  };
export const cleanFleetLoader = () => {
  console.log("mesaage-------------loader action");
    return {
      type:CLEAN_FLEET_LOADER,
    };
  };
  export function getUpdateFleet(data, callBack) {
    return {
      type: UPDATE_FLEET,
      payload:data,
      callBack
    };
  }
  export function updateFleetSuccess(data) {
    return {
      type: UPDATE_FLEET_SUCCESS,
      payload:data
    };
  };
  export function advancedVehicleListAction(payload){
    return {
      type:ADVANCED_VEHICLE_LIST,
      payload
    }
  }
  
  export function advancedVehicleListSuccess(payload){
    return {
      type:ADVANCED_VEHICLE_LIST_SUCCESS,
      payload
    }
  }

  export function saveVehicleProfileData(payload, callBack) {
    return {
      type: SAVE_VEHICLE_PROFILE_DATA,
      payload,
      callBack
    };
  }
  export function saveVehicleProfileDataSuccess(payload) {
    return {
      type: SAVE_VEHICLE_PROFILE_DATA_SUCCESS,
      payload,
    };
  }
  export function editVehicleProfileData(payload, callBack) {
    return {
      type: EDIT_VEHICLE_PROFILE_DATA,
      payload,
      callBack,
    };
  }
  export function editVehicleProfileDataSuccess(payload) {
    return {
      type: EDIT_VEHICLE_PROFILE_DATA_SUCCESS,
      payload,
    };
  }
  export function getVehicleProfileData(payload, callBack) {
    return {
      type: GET_VEHICLE_PROFILE_DATA,
      payload,
      callBack,
    };
  }
  export function clearVehicleProfileData(payload) {
    return {
      type: CLEAR_VEHICLE_PROFILE_DATA,
      payload,
    };
  }
  export function getVehicleProfileDataSuccess(payload) {
    return {
      type: GET_VEHICLE_PROFILE_DATA_SUCCESS,
      payload,
    };
  }

  export function getKarzaVehicleData(payload) {
    return {
      type: GET_KARZA_VEHICLE_DATA,
      payload,
    };
  }
  export function clearKarzaVehicleData(payload) {
    return {
      type: CLEAR_KARZA_VEHICLE_DATA,
      payload,
    };
  }
  export function getKarzaVehicleDataSuccess(payload) {
    return {
      type: GET_KARZA_VEHICLE_DATA_SUCCESS,
      payload,
    };
  }
  export function getServiceHistory(payload, callBack) {
    return {
      type: GET_SERVICE_HISTORY,
      payload,
      callBack,
    };
  }
  export function clearServiceHistory(payload) {
    return {
      type: CLEAR_SERVICE_HISTORY,
      payload,
    };
  }
  export function getServiceHistorySuccess(payload) {
    return {
      type: GET_SERVICE_HISTORY_SUCCESS,
      payload,
    };
  }

  export function deleteServiceHistory(payload, callBack) {
    return {
      type: DELETE_SERVICE_HISTORY,
      payload,
      callBack,
    };
  }
  export function deleteServiceHistorySuccess(payload) {
    return {
      type: DELETE_SERVICE_HISTORY_SUCCESS,
      payload,
    };
  }

  export function getServiceItems(payload, callBack) {
    return {
      type: GET_SERVICE_ITEMS,
      payload,
      callBack,
    };
  }
  export function getServiceItemsSuccess(payload) {
    return {
      type: GET_SERVICE_ITEMS_SUCCESS,
      payload,
    };
  }

  export function addServiceItems(payload, callBack) {
    return {
      type: ADD_SERVICE_ITEMS,
      payload,
      callBack,
    };
  }
  export function addServiceItemsSuccess(payload) {
    return {
      type: ADD_SERVICE_ITEMS_SUCCESS,
      payload,
    };
  }

  export function getAnalyticalData(payload, callBack) {
    return {
      type: GET_FLEET_ANALYTICS,
      payload,
      callBack,
    };
  }
  export function getAnalyticalDataSuccess(payload) {
    return {
      type: GET_FLEET_ANALYTICS_SUCCESS,
      payload,
    };
  }

  export const downloadVehicleLedgerAction = (fleetId, data, callBack) => {
    return {
      type: DOWNLOAD_VEHICLE_LEDGER,
      fleetId: fleetId,
      payload : data,
      callBack,
    };
  };
  
  export const ddownloadVehicleLedgerSuccessAction = (data) => {
    return { type: DOWNLOAD_VEHICLE_LEDGER_SUCCESS, payload: data };
  };

  export const uplaodTollTxn = (data, callBack) => {
    return {
      type: UPLOAD_TOLL_TXN,
      payload : data,
      callBack,
    };
  };
  
  export const uplaodTollTxnSuccess = (data) => {
    return { type: UPLOAD_TOLL_TXN_SUCCESS, payload: data };
  };


